export default __webpack_public_path__ + "static/media/2036.903e8ca2.png";